import { CircularProgress } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MotorButtons from "./MotorButtons";
import styles from "./styles.module.css";

const VersaoCard = ({ 
  versao, 
  motoresMap, 
  handleAnalisar,
  status,
  dadosProgresso,
  emProcessamento,
  isProjeto = false,
  podeNavegarMotores = true,
}) => {
  const isErro = status?.erro || dadosProgresso?.erro || status?.status === 'ERRO';
  const isConcluido = status?.concluido || dadosProgresso?.sucesso || status?.status === 'CONCLUIDO';
  const isAguardando = status?.aguardando || status?.status === 'AGUARDANDO' || status?.status === 'CRIADA_AGUARDANDO_EXECUCAO';
  const isProcessando = emProcessamento && !isErro && !isConcluido && !isAguardando;

  return (
    <div className={styles.itemVersao}>
      <div className={`${styles.itemHeader} ${isProjeto ? styles.versaoProjeto : ''}`}>
        <span>
          <h4>
            {versao.descricao}
            {isProjeto && (
              <span className={styles.tagProjeto}>
                Projeto
                {versao.statusProjeto === 'EM_ANALISE' && (
                  <span className={styles.tagStatus}> (Em Análise)</span>
                )}
                {versao.statusProjeto === 'APROVADO' && (
                  <span className={styles.tagStatusAprovado}> (Aprovado)</span>
                )}
                {versao.statusProjeto === 'REJEITADO' && (
                  <span className={styles.tagStatusRejeitado}> (Rejeitado)</span>
                )}
              </span>
            )}
          </h4>
          <p className={styles.itemDate}>
            {versao.dtCadastro
              ? new Date(versao.dtCadastro).toLocaleDateString("pt-BR")
              : "-"}
          </p>
        </span>
        
        {/* Indicador Aguardando */}
        {isAguardando && (
          <div className={styles.statusIndicatorAguardando}>
            <CircularProgress size={16} sx={{ marginRight: 1 }} />
            <span className={styles.statusTextAguardando}>
              {dadosProgresso?.mensagem || status?.mensagem || "Aguardando início..."}
            </span>
          </div>
        )}
        
        {/* Indicador Processando */}
        {isProcessando && (
          <div className={styles.statusIndicator}>
            <CircularProgress size={16} sx={{ marginRight: 1 }} />
            <span className={styles.statusText}>
              {dadosProgresso?.mensagem || status?.mensagem || "Processando..."}
              {dadosProgresso?.progresso !== undefined && ` (${dadosProgresso.progresso}%)`}
            </span>
          </div>
        )}
        
        {/* Indicador Erro */}
        {isErro && (
          <div className={styles.statusIndicatorError}>
            <ErrorIcon sx={{ fontSize: 18, marginRight: 1, color: '#d32f2f' }} />
            <span className={styles.statusTextError}>
              {status?.mensagem || dadosProgresso?.mensagem || "Erro ao processar"}
            </span>
          </div>
        )}
        
        {isConcluido && (
          <div className={styles.statusIndicatorSuccess}>
            <CheckCircleIcon sx={{ fontSize: 18, marginRight: 1, color: '#2e7d32' }} />
            <span className={styles.statusTextSuccess}>
              Concluído
            </span>
          </div>
        )}
      </div>

      <MotorButtons
        versao={versao}
        motoresMap={motoresMap}
        handleAnalisar={handleAnalisar}
        podeNavegarMotores={podeNavegarMotores}
      />
    </div>
  );
};

export default VersaoCard;

